// extracted by mini-css-extract-plugin
module.exports = {"message":"style_message__3eCio","icon":"style_icon__1HYyZ","title":"style_title__37k8Q"};